.bigPlay {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 96px;
  height: 96px;
  border: 0;
  background: transparent;
  cursor: pointer;
  z-index: 4;
  display: grid;
  place-items: center;
  transition: transform 0.2s ease;
}

.bigPlay:hover {
  transform: scale(1.07);
}

.bigPlay:active {
  transform: scale(0.97);
}

.halo {
  position: absolute;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(225, 29, 46, 0.35) 0%, transparent 70%);
  animation: pulse 2.2s ease-in-out infinite;
  pointer-events: none;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.18);
    opacity: 0.25;
  }
}
